export default "__VITE_ASSET__BVld0Qsy__"